import { axiosBase, errorHandler } from "./axios";



const getSchoolByRatings = (data: any) => {
  return axiosBase.get(`reviews/getSchoolByRatings`, { params: data })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}



const listReviews = (params: any) => {
  return axiosBase
    .get("reviews/student/list", { params })
    .then((r) => r.data)
    .catch(errorHandler);
};

const getInstructorRatings = (instructorId: string) => {
  return axiosBase
    .get(`reviews/instructor/${instructorId}/ratings`)
    .then((r) => r.data)
    .catch(errorHandler);
};

const getSchoolRatings = (params?: any) => {
  return axiosBase
    .get("reviews/school/ratings", { params })
    .then((r) => r.data)
    .catch(errorHandler);
};

const deleteReview = (id: string) => {
  return axiosBase
    .delete(`reviews/${id}`)
    .then((r) => r.data)
    .catch(errorHandler);
};

const viewReview = (id: string) => {
  return axiosBase
    .get(`reviews/view/${id}`)
    .then((r) => r.data)
    .catch(errorHandler);
};

export const reviewService = {
  listReviews,
  getInstructorRatings,
  getSchoolRatings,
  deleteReview,
  viewReview,
  getSchoolByRatings
};